import styled, {css} from 'styled-components';

import {mixins} from '../styles';

type TProps = TTheme & {
  isInvalid?: boolean;
  checked?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
};

const getRadioDisabledStyle = ({disabled, readOnly, theme}: TProps) => {
  if (disabled) {
    return css`
      color: ${theme.palette.grey300};
      cursor: not-allowed;
    `;
  }

  if (readOnly) {
    return css`
      cursor: auto;
    `;
  }

  return css`
    cursor: pointer;
  `;
};

export const Radio = styled.label<TProps>`
  /* for HiddenInput */
  position: relative;
  display: flex;
  justify-content: unset;
  ${getRadioDisabledStyle}
`;

const getControlStyle = ({theme, checked}: TProps) => css`
  ${mixins.round(`${theme.dimensions.radioButtonSize}px`)}
  border-width: ${checked ? 6 : 2}px;
  background-color: ${theme.palette.white};
`;

const getBorderControlStyle = ({theme, disabled, readOnly, isInvalid}: TProps) => {
  if (disabled) {
    return css`
      border-color: ${theme.palette.grey300};
    `;
  }

  if (readOnly) {
    return css`
      border-color: ${theme.branding.colors.disabled};
    `;
  }

  if (isInvalid) {
    return css`
      border-color: ${theme.palette.red400};
    `;
  }

  return css`
    border-color: ${theme.branding.content.primary};
  `;
};

export const ControlWrapper = styled.div`
  ${mixins.flexAlign('center')}
  ${mixins.wh('24px')}
`;

export const Control = styled.span<TProps>`
  border-style: solid;
  ${getControlStyle}
  ${getBorderControlStyle}
`;

export const Label = styled.span`
  ${mixins.breakWord}
  ${({theme}) => css`
    margin-left: ${theme.spacing.s2};
    padding: ${theme.spacing.s05} 0;
  `}
`;
